import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function EditBox(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M18.221 4.336a1.04 1.04 0 011.558 1.38l-7.326 8.39-2.079.52.536-2.143 7.311-8.147zm2.646-1.7A3.04 3.04 0 0016.733 3l-7.477 8.332a1 1 0 00-.226.425l-1 4a1 1 0 001.213 1.213l4-1a1 1 0 00.51-.312l7.533-8.627a3.04 3.04 0 00-.419-4.396zM6 2a4 4 0 00-4 4v12a4 4 0 004 4h12a4 4 0 004-4v-7a1 1 0 10-2 0v7a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h7a1 1 0 100-2H6z",
    clipRule: "evenodd"
  }));
}

export default EditBox;